import api from '../utils/api';
import { getAuthHeaders } from '../context/auth/Auth';


export const getAllRoles = async (): Promise<any> => {
    return await api.get('/evroles?_limit=-1',
        { headers: { ...getAuthHeaders() }, params: {} }
    ).then((response) => response.data);
};